import * as React from "react";
import { Route, useLocation } from "wouter";
import { useAuth } from "@/contexts/AuthContext";

interface PublicRouteProps {
  path: string;
  component: React.ComponentType;
}

function PublicRouteWrapper({ component: Component }: { component: React.ComponentType }) {
  const { isAuthenticated, isLoading } = useAuth();
  const [, setLocation] = useLocation();

  React.useEffect(() => {
    if (!isLoading && isAuthenticated) {
      setLocation("/user");
    }
  }, [isLoading, isAuthenticated, setLocation]);

  if (isLoading) {
    return (
      <div className="h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent"></div>
          <p className="mt-4 text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (isAuthenticated) {
    return (
      <div className="h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent"></div>
          <p className="mt-4 text-muted-foreground">Redirecting...</p>
        </div>
      </div>
    );
  }

  return <Component />;
}

export function PublicRoute({ path, component: Component }: PublicRouteProps) {
  return (
    <Route path={path}>
      {() => <PublicRouteWrapper component={Component} />}
    </Route>
  );
}
